export default __webpack_public_path__ + "966912a7de1a7fb55319bb5fcd04de64.png";